import * as actionTypes from "../actions/types";
import _ from "underscore";
import { dateToString } from "../helpers/utils.js";

const initialState = {
  allFiles: [],
  allSpecifications: [],
  lastUpdates: [],
  publications: [],
  lastSpecifications: []
};

const getAllFiles = all => {
  const toRet = _.map(all, function(value) {
    return {
      ...value,
      publishAtString: dateToString(new Date(value.publishAt))
    };
  });
  return toRet;
};

///ALL SPECIFICATIONS
const getAllSpecifications = state => {
  const grouped = _.groupBy(state.allFiles, "chapterIdentity");
  const all = _.map(grouped, function(value, key) {
    const editions = getEditions(value);
    const lastEdition = editions[0];
    const lastEditionPublishAt = new Date(lastEdition.publishAt);
    return {
      id: key,
      key: Number(lastEdition.chapterIdForName),
      idForName: lastEdition.chapterIdForName,
      name: lastEdition.chapterIdForName + " | " + lastEdition.chapterName,
      description: lastEdition.chapterName,
      publishAt: dateToString(lastEditionPublishAt),
      publishAtDate: lastEditionPublishAt,
      numberOfEditions: editions.length + " מהדורות",
      numberOfFixes:
        lastEdition.fixes && lastEdition.fixes.length > 0
          ? lastEdition.fixes.length + " דפי תיקון"
          : "אין דפי תיקון",
      editions: {
        ...editions
      }
    };
  });
  return _.sortBy(all, "key");
};

const getLastSpecifications = allSpecifications => {
  const lastSpecifications = _.map(allSpecifications, function(value) {
    if (value.editions && value.editions[0]) {
      const lastEdition = value.editions[0];
      let arr = [];
      if (lastEdition.fixes && lastEdition.fixes.length > 0) {
        arr = _.map(lastEdition.fixes, function(fix) {
          return {
            id: fix.id,
            pdfName: fix.pdfName
          };
        });
      }

      arr.splice(0, 0, {
        id: lastEdition.id,
        pdfName: lastEdition.pdfName
      });

      return arr;
    }
  });
  return _.flatten(lastSpecifications);
};

const getEditions = editions => {
  let editionsGrouped = _.groupBy(editions, "docParentID");
  let mainEditionsSorted = _.sortBy(editionsGrouped[""], "publishAt").reverse();
  const toReturn = _.map(mainEditionsSorted, function(value) {
    const fixes = _.map(editionsGrouped[value.docIdentity], data => {
      return {
        ...data,
        year: new Date(data.publishAt).getFullYear()
      };
    });
    return {
      ...value,
      year: new Date(value.publishAt).getFullYear(),
      fixes: fixes
    };
  });
  return toReturn;
};

///PUBLICATIONS
const getAllPublications = state => {
  const publications = _.filter(
    state.allFiles,
    file => file.chapterIdentity == 73
  );
  const publicationsSorted = _.sortBy(publications, "publishAt").reverse();
  return publicationsSorted;
};

///LAST UPDATES
const getLastUpdates = state => {
  const updates = _.sortBy(state.allFiles, "publishAt")
    .reverse()
    .slice(0, 10);
  const toRet = _.map(updates, function(value) {
    return {
      ...value,
      name: value.chapterIdForName + " | " + value.chapterName
    };
  });
  return toRet;
};

const reverseList = (list, toSortBy, descending) => {
  let toReturn = _.sortBy(list, toSortBy);
  if (descending === false) {
    toReturn.reverse();
  }
  return toReturn;
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ALL:
      const files = getAllFiles(action.payload);
      return {
        ...state,
        allFiles: files
      };
    case actionTypes.ALL_SPECIFICATIONS:
      const all = getAllSpecifications(state);
      const lastSpecifications = getLastSpecifications(all);
      return {
        ...state,
        lastSpecifications: lastSpecifications,
        allSpecifications: all
      };
    // case actionTypes.LAST_SPECIFICATIONS:
    //   const last = getLastSpecifications(state);
    //   return {
    //     ...state,
    //     lastSpecifications: last
    //   };
    case actionTypes.ALL_SPECIFICATIONS_REVERSE:
      const allSpecificationsReversed = reverseList(
        state.allSpecifications,
        "key",
        action.payload
      );
      return {
        ...state,
        allSpecifications: allSpecificationsReversed
      };
    case actionTypes.PUBLICATIONS:
      const allPublications = getAllPublications(state);
      return {
        ...state,
        publications: allPublications
      };
    case actionTypes.PUBLICATIONS_REVERSE:
      const publicationsReversed = state.publications.reverse();
      return {
        ...state,
        publications: publicationsReversed
      };
    case actionTypes.LAST_UPDATES:
      const lastUpdates = getLastUpdates(state);
      return {
        ...state,
        lastUpdates: lastUpdates
      };
    case actionTypes.LAST_UPDATES_REVERSE:
      const lastUpdatesReversed = state.lastUpdates.reverse();
      return {
        ...state,
        lastUpdates: lastUpdatesReversed
      };
    default:
      return state;
  }
}
